$(document)

    // All elements with the data-attr "[data-mix-id]" will add a mix to cart
    .on('click', '[data-mix-id]', function(e) {
        e.preventDefault();
        var id = e.target.dataset.mixId;
        Shop.Cart.addMix(id);
        App.Interface.Api.get('products/' + id, {}, {}, function(product) {
            App.Interface.Notification.add('floating', App.Template.parse('notification-cart-add', {
                'name':     product.name,
                'text':     product.description,
                'image':    'assets/img/offersStatic/Cart/de_DE/custom.png',
                'url':      '/shop/cart',
                'amount':   1,
            })).update();
        });
    })

    // Add product to cart
    .on('click', '[data-product-id]', function(e) {
        e.preventDefault();
        App.execute('Offer-List', e);
    })

    // Encash voucher code
    .on('click', '[data-voucher-code]', function(e) {
        e.preventDefault();
        App.execute('Voucher-Encash', e);
    })

    // Add offer to cart
    .on('click', '[data-offer-id]', function(e) {
        e.preventDefault();
        const component = e.target.getComponent();
        const content = component.content;
        const icon = e.target.firstChild.classList.contains('icon') ? e.target.firstChild : null;
        // @todo: it could be something else than a button component
        component.content = App.Template.parse('button-icon-loading');

        if (icon) {
            e.target.firstChild.classList.remove('icon');
        }

        Shop.Cart.addOffer(e.target.dataset.offerId, e.target.dataset.offerAmount || 1, function() {
            component.content = content;

            if (icon) {
                e.target.firstChild.classList.add('icon');
            }

            component.changeToOriginalInstance();
        });
    })

    // Bind global add ingredient method
    .on('click', '[data-add-ingredient]', function () {
        let element     = $(this);
        let id          = element.data('ingredient-id');
        let amount      = element.data('ingredient-amount')     ? element.data('ingredient-amount')     : 1 ;
        let instance    = element.data('ingredient-instance');
        App.Interface.Recipe.addIngredient(id, amount, instance);
    })
;
